import styled from 'styled-components/macro';

const SpacingBottom = styled.div`
  margin-bottom: ${props => (props.large ? props.theme.spacing.l : props.theme.spacing.xs)};
`;

export default SpacingBottom;
